import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Label } from 'reactstrap';
import { DatePicker } from 'antd';
import moment from 'moment';

// Local Deps
import './RFFDateField.scss';

// const dateFormat = 'YYYY-MM-DD';
function RFFDateField({
  input,
  meta,
  inputCol,
  labelCol,
  errorCol,
  label,
  isRequired,
  changeDate,
  disabled,
  // options,
  // mode,
  // defaultValue,
  // ...otherProps,
}) {
  const _OnChange = (value, valueString) => {
    if (changeDate) {
      changeDate(input, valueString);
    } else {
      input.onChange(valueString);
    }
  };

  const _disabledDate = current => current && current < moment().endOf('day');

  return (
    <div className="nf-rff-input-field">
      <Row className="nf-rff-input-field__row">
        {/* <!-- LABEL --> */}
        {label && (
          <Col {...labelCol}>
            <Label className="nf-rff-input-field__label" htmlFor={input.name}>
              {label}
              {isRequired && (
                <span className="nf-rff-input-field__required">*</span>
              )}
            </Label>
          </Col>
        )}

        {/* <!-- INPUT --> */}
        <Col {...inputCol}>
          <DatePicker
            disabledDate={_disabledDate}
            disabled={disabled}
            className="nf-rff-date-field__input"
            value={input.value ? moment(input.value) : null}
            onChange={_OnChange}
          />
        </Col>

        {/* <!-- ERROR -> */}
        {meta.touched &&
          meta.error && (
            <Col {...errorCol}>
              <div className="nf-rff-input-field__error">{meta.error}</div>
            </Col>
          )}
      </Row>
    </div>
  );
}

RFFDateField.defaultProps = {
  label: '',
  labelCol: { md: 3 },
  inputCol: { md: 6, className: 'text-left' },
  errorCol: { md: 3 },
  isRequired: false,
  mode: '',
  defaultValue: [],
  disabled: false,
};
RFFDateField.propTypes = {
  input: PropTypes.object.isRequired, // Supplied by React Final Form
  meta: PropTypes.object.isRequired, // Supplied by React Final Form,
  labelCol: PropTypes.object,
  inputCol: PropTypes.object,
  errorCol: PropTypes.object,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  options: PropTypes.array.isRequired,
  mode: PropTypes.string,
  defaultValue: PropTypes.string,
  changeDate: PropTypes.func.isRequired,
};

export default RFFDateField;



// WEBPACK FOOTER //
// ./src/components/form/RFFDateField/RFFDateField.jsx